module.exports = __webpack_public_path__ + "static/media/go-home.c496cb1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/battery/go-home.png
// module id = 478
// module chunks = 0